export const TASK_STATUS = {
    CANCELLED: 'CANCELLED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    NOT_STARTED: 'NOT_STARTED',
    PENDING_REVIEW: 'PENDING_REVIEW',
} as const;

export const TASK_STATUSES = Object.values(TASK_STATUS);

export const TASK_STATUSES_CONSIDERED_ACTIVE = TASK_STATUSES.filter(
    (s) => s !== TASK_STATUS.COMPLETED
);

export const TASK_PRIORITY = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    URGENT: 'URGENT',
} as const;

export const TASK_PRIORITIES = Object.values(TASK_PRIORITY);

export const TASK_EXECUTION_TYPE = {
    COMPANY: 'Company',
    REPORT: 'Report',
    SCHEMA: 'Schema',
} as const;
